var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobe28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0506 2.28113C14.1716 2.03288 14.4708 1.92968 14.7191 2.05062C18.8371 4.05684 21.0001 8.46617 21.0001 13.5001C21.0001 18.5341 18.8371 22.9434 14.7191 24.9496C14.4708 25.0705 14.1716 24.9673 14.0506 24.7191C13.9297 24.4708 14.0329 24.1716 14.2811 24.0506C17.9631 22.2568 20.0001 18.2662 20.0001 13.5001C20.0001 8.73406 17.9631 4.74338 14.2811 2.94961C14.0329 2.82867 13.9297 2.52938 14.0506 2.28113Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9495 2.28113C15.0704 2.52938 14.9672 2.82867 14.719 2.94961C11.037 4.74338 9 8.73406 9 13.5001C9 18.2662 11.037 22.2568 14.719 24.0506C14.9672 24.1716 15.0704 24.4708 14.9495 24.7191C14.8286 24.9673 14.5293 25.0705 14.281 24.9496C10.163 22.9434 8 18.5341 8 13.5001C8 8.46617 10.163 4.05684 14.281 2.05062C14.5293 1.92968 14.8286 2.03288 14.9495 2.28113Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 2C14.7761 2 15 2.22386 15 2.5V24.5C15 24.7761 14.7761 25 14.5 25C14.2239 25 14 24.7761 14 24.5V2.5C14 2.22386 14.2239 2 14.5 2Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 13.5C3 13.2239 3.22386 13 3.5 13H25.5C25.7761 13 26 13.2239 26 13.5C26 13.7761 25.7761 14 25.5 14H3.5C3.22386 14 3 13.7761 3 13.5Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 3C8.70101 3 4 7.70101 4 13.5C4 19.299 8.70101 24 14.5 24C20.299 24 25 19.299 25 13.5C25 7.70101 20.299 3 14.5 3ZM3 13.5C3 7.14873 8.14873 2 14.5 2C20.8513 2 26 7.14873 26 13.5C26 19.8513 20.8513 25 14.5 25C8.14873 25 3 19.8513 3 13.5Z",
  fill: "currentColor"
})));
export default SvgGlobe28;